module.exports = __webpack_public_path__ + "img/jackpot-bg_1248.006b6ba1.png";